import { useShallow } from "zustand/react/shallow";

import ThemeSwitcher from "~/components/ThemeSwitcher";
import { langStore } from "~/stores/lang";
import { userStore } from "~/stores/user";
import { notificationStore } from "~/stores/notification";
import { setUserLang } from "~/providers/api";
import { LANG_CS, LANG_EN } from "~/const";

// prepinac CZ / EN (vypada stejne jako prepinac rezimu), prihlasenemu uzivateli se jazyk ulozi i na server
export default function LangSwitcher() {
	const { lang, setLang } = langStore(useShallow(state => ({
		lang: state.lang,
		setLang: state.setLang,
	})));
	const jwt = userStore(state => state.user.jwt);
	const setNotification = notificationStore(state => state.setNotification);

	async function changeLang(isEnglish: boolean) {
		const newLang = isEnglish ? LANG_EN : LANG_CS;

		setLang(newLang);

		if (jwt) {
			const data = await setUserLang(jwt, newLang);

			if (!data.noErrors) {
				setNotification(data.errors.join(", "), "error");
			}
		}
	}

	return <ThemeSwitcher
		id="langSwitcherInput"
		state={lang === LANG_EN}
		onChange={data => changeLang(data.state)}
		leftIcon={<span>CZ</span>}
		rightIcon={<span>EN</span>}
	/>;
}
